<template>
  <q-header class="giscube-header">
    <q-toolbar class="giscube-toolbar">
      <home-header-item
        :homeIcon="$config.layout.home.homeIcon"
        :defaultTab="$config.layout.home.defaultTab"
      />
      <q-separator vertical dark inset></q-separator>
      <a class="giscube-header-brand cursor-pointer q-mx-sm" :href="brandLink" v-touch-hold:2500.mouse="infoPopup">
        <img :src="brandLogo" />
        <span v-if="!$q.platform.is.mobile" v-html="brandText"></span>
      </a>

      <search-bar />
      <slot name="extra-tools-left" v-if="!$q.platform.is.mobile"/>
      <header-item-holder
        v-for="(item, i) in printHeaderTools"
        :key="'header-tools-' + item.name + '-' + i"
        class="gt-xs"
        :class="{
            ['header-tools-' + item.name]: true,
            print: item.tool && item.tool.print
        }"
        :item="item"
        @event="emit"
      />
      <q-space />
      <slot name="extra-tools-right" v-if="!$q.platform.is.mobile"/>
      <slot name="auth-header-item">
        <auth-header-item />
      </slot>
      <slot name="tools-header-item">
        <tools-header-item />
      </slot>
    </q-toolbar>

  </q-header>
</template>

<script>
import { QHeader, QSpace, QSeparator, QToolbar, TouchHold } from 'quasar'

import AuthHeaderItem from 'components/Header/AuthHeaderItem.vue'
import HeaderItemHolder from 'components/Header/HeaderItemHolder.js'
import HomeHeaderItem from 'components/Header/HomeHeaderItem.vue'
import ToolsHeaderItem from 'components/Header/ToolsHeaderItem.vue'
import SearchBar from 'components/Header/SearchBar'

export default {
  name: 'AppHeader',
  props: [
    'brandLogo',
    'brandText',
    'brandLink'
  ],
  components: {
    AuthHeaderItem,
    HomeHeaderItem,
    ToolsHeaderItem,
    HeaderItemHolder,
    SearchBar,
    QHeader,
    QSeparator,
    QSpace,
    QToolbar
  },
  directives: {
    TouchHold
  },
  data () {
    return {}
  },
  computed: {
    home () {
      return this.generateToolsFromList(['home'], { separators: false })
    },
    printing () {
      return this.$store.state.layout.printing
    },
    headerTools () {
      return !this.printing ? this.generateToolsFromList(this.$config.layout.headerToolbar) : []
    },
    printHeaderTools () {
      return this.printing ? this.generateToolsFromList(this.$config.layout.printHeaderToolbar, { separators: false }) : []
    }
  },
  methods: {
    emit (event) {
      this.$emit(event.name.toString(), event.value)
    },
    generateToolsFromList (list, { separators = false } = {}) {
      const tools = this.$config.tools
      let addSeparator = separators
      const r = []
      list.forEach((toolName, i) => {
        if (toolName.constructor === Object) {
          const items = toolName.items.map(name => {
            return name.startsWith('-') ? { separator: true, name: 'separator-' + i } : { name: name, tool: tools[name] }
          })
          if (addSeparator) {
            r.push({ separator: true, name: 'separator-' + i })
          } else {
            // only skip a single one
            addSeparator = separators
          }
          r.push({ icon: toolName.icon, label: toolName.label, items: items })
        } else if (toolName.startsWith('-')) {
          r.push({ spacer: true, name: 'spacer-' + i })
          addSeparator = false // skip next separator
        } else if (toolName in tools) {
          if (addSeparator) {
            r.push({ separator: true, name: 'separator-' + i })
          } else {
            // only skip a single one
            addSeparator = separators
          }

          r.push({ name: toolName, tool: tools[toolName] })
        } else {
          console.warn(`[AppHeader.vue] Tool "${toolName}" is not defined in the current configuration.`)
        }
      })
      return r
    },
    infoPopup () {
      this.$store.dispatch('layout/createDialog', {
        root: this,
        title: 'Development information'
      })
    }
  }
}
</script>

<style>
.q-toolbar {
  padding: 0;
}
.full-min-width {
  min-width: 100% !important;
  display: inline-block;
}
/* q-header */
.giscube-header {
  background-color: #f8f9fa !important;
  border-bottom: 1px solid #ccc !important;
  padding: 0px !important;
  color: #0a1924 !important;
  font-family: 'Lato', sans-serif !important;
}
a.giscube-header-brand {
  padding: 6px 0px 6px 0px !important;
  overflow: visible !important;
  white-space: nowrap !important;
}
a.giscube-header-brand img {
  height: 20px !important;
  margin-right: 8px !important;
  margin-left: 8px !important;
  margin-top: 1px !important;
  vertical-align: center !important;
}
a.giscube-header-brand span {
  vertical-align: center !important;
  margin-top: 2px !important;
  margin-right: 8px !important;
  font-weight: 300 !important;
  font-size: 14px !important;
  display: inline-block !important;
  line-height: 1em !important;
}
a.giscube-header-brand {
  color: inherit !important;
}
</style>
